export type PricingTier = {
  label: string;
  price: string;
  color:
    | "default"
    | "success"
    | "info"
    | "warning"
    | "error"
    | "primary"
    | "secondary";
};

export type NextTierWarning = {
  nextLabel: string;
  nextPrice: string;
};

export const getPricingTier = (memberCount: number): PricingTier => {
  if (memberCount <= 5) return { label: "Free", price: "£0/mth", color: "success" };
  if (memberCount <= 24) return { label: "Starter", price: "£9/mth", color: "info" };
  if (memberCount <= 49) return { label: "Club", price: "£14/mth", color: "primary" };
  if (memberCount <= 99) return { label: "Pro", price: "£19/mth", color: "warning" };
  return { label: "Enterprise", price: "Custom", color: "secondary" };
};

export const getNextTierWarning = (
  memberCount: number,
): NextTierWarning | null => {
  if (memberCount === 5) return { nextLabel: "Starter", nextPrice: "£9/mth" };
  if (memberCount === 24) return { nextLabel: "Club", nextPrice: "£14/mth" };
  if (memberCount === 49) return { nextLabel: "Pro", nextPrice: "£19/mth" };
  if (memberCount === 99)
    return { nextLabel: "Enterprise", nextPrice: "custom pricing" };
  return null;
};
